import { API } from '@/api'

export const getBrands = () => API.get('/dataset/brands/');
